// Step 10 — progress (streak + XP) shapes shared by Worker and frontend.
//
// streak is user-level (`users.current_streak` / `longest_streak` /
// `last_activity_date`). XP and bonus_unlocked stay pack-level
// (`user_progress`). See spec line 678 ("跨 pack 共用") for the rationale.

import { z } from 'zod'
import { packIdSchema } from './api.ts'
import { localDateSchema } from './practice.ts'

export const packProgressSchema = z
  .object({
    packId: packIdSchema,
    totalXp: z.number().int().nonnegative(),
    itemsUnlocked: z.number().int().nonnegative(),
    totalItems: z.number().int().positive(),
    bonusUnlocked: z.boolean(),
  })
  .strict()
export type PackProgress = z.infer<typeof packProgressSchema>

export const progressResponseSchema = z
  .object({
    /** Cross-pack streak. Spec: streak is shared, XP is per-pack. */
    currentStreak: z.number().int().nonnegative(),
    longestStreak: z.number().int().nonnegative(),
    /** Last day the user answered at all (null = brand new account). */
    lastActivityDate: localDateSchema.nullable(),
    packs: z.array(packProgressSchema),
  })
  .strict()
export type ProgressResponse = z.infer<typeof progressResponseSchema>
